export default {
	async fetchNotifications(context) {
		const token = localStorage.getItem('token');
		const userId = localStorage.getItem('userId');
		const league = localStorage.getItem('league');
		const team = localStorage.getItem('team');
		const response = await fetch(
			`https://six4three-7a0ac-default-rtdb.firebaseio.com/posts/global.json?auth=` + token,
			{
				method: 'GET',
			}
		);
		const responseData = await response.json();

		if (!response.ok) {
			const error = new Error(responseData.message || 'Failed');
			throw error;
		}
		const notifyUser = [];
		for (const key in responseData) {
			var notify = true;
			const notification = {
				id: key,
				byUserId: responseData[key].byUserId,
				byUser: responseData[key].byUser,
				byUserTeam: responseData[key].byUserTeam,
				byUserLeague: responseData[key].byUserLeague,
				title: responseData[key].title,
				message: responseData[key].message,
				timeStamp: responseData[key].timeStamp,
				likes: responseData[key].likes,
				dislikes: responseData[key].dislikes,
				dislikedBy: responseData[key].dislikedBy,
				likedBy: responseData[key].likedBy,
				viewedBy: responseData[key].viewedBy,
				group: 'Global',
			};
			for (const index in responseData[key].viewedBy) {
				if (responseData[key].viewedBy[index] === userId || responseData[key].byUserId === userId) {
					notify = false;
				}
			}
			if (notify === true) {
				notifyUser.push(notification);
				context.commit('setNotificationStatus', 'true');
				localStorage.setItem('notificationStatus', 'true');
			}
		}
		const response2 = await fetch(
			`https://six4three-7a0ac-default-rtdb.firebaseio.com/posts/leagues/${league}.json?auth=` + token,
			{
				method: 'GET',
			}
		);
		const responseData2 = await response2.json();

		if (!response2.ok) {
			const error = new Error(responseData2.message || 'Failed');
			throw error;
		}
		for (const key in responseData2) {
			var notify = true;
			const post = {
				id: key,
				byUserId: responseData2[key].byUserId,
				byUser: responseData2[key].byUser,
				byUserTeam: responseData2[key].byUserTeam,
				byUserLeague: responseData2[key].byUserLeague,
				byUserDivision: responseData2[key].byUserDivision,
				byUserType: responseData2[key].byUserType,
				title: responseData2[key].title,
				message: responseData2[key].message,
				timeStamp: responseData2[key].timeStamp,
				comments: responseData2[key].comments,
				commentCount: responseData2[key].commentCount,
				likes: responseData2[key].likes,
				dislikes: responseData2[key].dislikes,
				dislikedBy: responseData2[key].dislikedBy,
				likedBy: responseData2[key].likedBy,
				viewedBy: responseData2[key].viewedBy,
				group: 'League',
			};
			for (const index in responseData2[key].viewedBy) {
				if (responseData2[key].viewedBy[index] === userId || responseData2[key].byUserId === userId) {
					notify = false;
				}
			}
			if (notify === true) {
				notifyUser.push(post);
				context.commit('setNotificationStatus', 'true');
				localStorage.setItem('notificationStatus', 'true');
			}
		}
		const response3 = await fetch(
			`https://six4three-7a0ac-default-rtdb.firebaseio.com/posts/teams/${league}/${team}.json?auth=` + token,
			{
				method: 'GET',
			}
		);
		const responseData3 = await response3.json();

		if (!response3.ok) {
			const error = new Error(responseData3.message || 'Failed');
			throw error;
		}
		for (const key in responseData3) {
			var notify = true;
			const post = {
				id: key,
				byUserId: responseData3[key].byUserId,
				byUser: responseData3[key].byUser,
				byUserTeam: responseData3[key].byUserTeam,
				byUserLeague: responseData3[key].byUserLeague,
				byUserDivision: responseData3[key].byUserDivision,
				byUserType: responseData3[key].userType,
				title: responseData3[key].title,
				message: responseData3[key].message,
				timeStamp: responseData3[key].timeStamp,
				comments: responseData3[key].comments,
				commentCount: responseData3[key].commentCount,
				likes: responseData3[key].likes,
				dislikes: responseData3[key].dislikes,
				dislikedBy: responseData3[key].dislikedBy,
				likedBy: responseData3[key].likedBy,
				viewedBy: responseData3[key].viewedBy,
				group: 'Team',
			};
			for (const index in responseData3[key].viewedBy) {
				if (responseData3[key].viewedBy[index] === userId || responseData3[key].byUserId === userId) {
					notify = false;
				}
			}
			if (notify === true) {
				notifyUser.push(post);
				context.commit('setNotificationStatus', 'true');
				localStorage.setItem('notificationStatus', 'true');
			}
		}
		context.commit('setNotificationCount', notifyUser.length);
		context.commit('notification', notifyUser);
	},
	async removeNotification(context, payload) {
		const token = localStorage.getItem('token');
		const postId = payload.postId;
		const league = localStorage.getItem('league');
		const team = localStorage.getItem('team');
		const group = payload.group
		let url = 'https://six4three-7a0ac-default-rtdb.firebaseio.com/posts/'
		let urlParam = `global/${postId}.json?auth=` + token;
		if (group === 'League') {
			urlParam = `leagues/${league}/${postId}.json?auth=` + token;
		} else if (group === 'Team') {
			urlParam = `teams/${league}/${team}/${postId}.json?auth=` + token;
		}
		const post = {
			viewedBy: payload.viewedBy,
		};
		const response = await fetch(
			url + urlParam,
			{
				method: 'PATCH',
				body: JSON.stringify(post),
			}
		);
		const responseData = await response.json();

		if (!response.ok) {
			const error = new Error(responseData.message || 'Failed');
			throw error;
		}
	},
	async resetNotifications(context) {
		context.commit('setNotificationStatus', 'false');
		localStorage.setItem('notificationStatus', 'false');
	},
};